import {
  ViewContainerRef,
  AfterViewInit,
  Component,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { ICellEditorAngularComp } from "ag-grid-angular/main";
import { Broadcast } from "../../../../core/events/broadcast";
import { AgRendererComponent } from "ag-grid-angular/dist/interfaces";
import { IAfterGuiAttachedParams } from "ag-grid/dist/lib/interfaces/iComponent";
import { IXSDropdownComponent } from "../../../dropdown/dropdown.component";
import { ICellRendererParams } from "ag-grid/dist/lib/rendering/cellRenderers/iCellRenderer";
import { MapConfiguration } from "../../../config";
import { RowNode } from "ag-grid/dist/lib/entities/rowNode";
import { SyncValue } from "../../../../core/service/syncdata.service";
import { DimensionValue } from "../../../ixs-fidimension/fidimension/fidimensionbase.component";

@Component({
  selector: "select-cell",
  template: `
    <ixs-fidimension
      #select
      (change)="valueChange()"
      [(ngModel)]="value"
      (afterDimenstionSelected)="dimensionSelected($event)"
      [Values]="Values"
      (onOpenDimenstion)="onOpenDimenstion()"
    >
    </ixs-fidimension>
  `
})
export class GridDimensionComponent implements AgRendererComponent {
  @ViewChild("select") dropdown: any;

  refresh(params: any): boolean {

    return true;
  }
  afterGuiAttached(params?: IAfterGuiAttachedParams): void {

  }
  private params: any;

  private column: any;

  public value: any;

  constructor() { }

  private async loadData() {

    this.dropdown.fieldName = this.column.colId + this.params.rowIndex;
    this.dropdown.showCaption = false;
    this.dropdown.valueMember = this.column.colDef.dataValueField;
    this.dropdown.displayMember = this.column.colDef.dataDisplayField;
    this.dropdown.caption = this.column.colDef.headerName;
    this.dropdown.config = this.column.colDef.config;
    this.dropdown.data = this.column.colDef.dropdownData;
    this.dropdown.Values = this.column.colDef.Values;
    this.dropdown.disabled = !Boolean(
      this.params.colDef.editable === undefined
        ? true
        : this.params.colDef.editable
    );
  }

  async agInit(params: ICellRendererParams) {
    const element: HTMLElement = this.dropdown.element.nativeElement.children[0].children[0]
      .children[0];
    if (element) {
      element.classList.add('grid-select-control');
      element.style.width = "100%";
    }
    const span: HTMLElement = this.dropdown.element.nativeElement.children[0].children[0]
      .children[1];
    if (span) {
      span.classList.add('grid-icon-control');
      span.classList.add('grid-input-search-icon');
    }
    this.params = params;
    this.value = this.params.getValue();
    this.column = this.params.column;
    await this.loadData();
    this.value = !this.value ? this.column.colDef.value : this.value;
    params.node.setDataValue(
      this.column.colDef.field,
      !this.value ? this.column.colDef.value : this.value
    );
    this.mapFields();
    if (this.column && this.column.colDef && this.column.colDef.focus && this.column.colDef.focus === true) {
      await this.setDimentionControlFocused();
    }
    const span1: HTMLElement = this.dropdown.element.nativeElement.children[0].children[0].children[1];
    if (span1) {
        span1.classList.remove('dropdown-radius');
    }
  }

  getValue(): any {
    return this.params.value;
  }

  valueChange() {

    this.params.setValue(this.value);

    this.mapFields();
  }

  mapFields() {
    if (
      this.params &&
      this.params.node &&
      this.column.colDef.mapFields &&
      this.dropdown.data &&
      this.value
    ) {
      this.column.colDef.mapFields.forEach((element: MapConfiguration) => {
        const data = this.dropdown.data.filter(
          o => o[this.dropdown.valueMember] === this.value
        )[0];
        if (data) {
          const val = data[element.mapField];
          if (val) {
            this.params.node.setDataValue(element.field, val);
          }
        }
      });
    }
  }

  dimensionSelected(event) {

    this.params.colDef.Values = event;
    this.params.colDef.displayMemberValue = this.dropdown.displayMemberValue;
    this.params.colDef.afterDimenstionSelected(this.params);
  }
  async onOpenDimenstion() {

    //this.params.colDef.Values = event;
    this.params.colDef.onOpenDimenstion(this.params);
    this.params = this.params;

    await this.agInit(this.params);

    // await this.loadData();
  }

  get Values(): Array<DimensionValue> {
    return this.params.colDef.Values;
  }
  @Input()
  set Values(value: Array<DimensionValue>) {

    this.params.colDef.Values = value;
  }

  public async setDimentionControlFocused() {
    if (this.dropdown && this.dropdown.element && this.dropdown.element.nativeElement && this.dropdown.element.nativeElement.children) {
      this.dropdown.element.nativeElement.children[0].children[0].children[0].focus();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/grid/editors/dimension/griddimension.component.ts